module.exports = __webpack_public_path__ + "static/media/user-feedback.af90fc2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/user-feedback.png
// module id = 686
// module chunks = 0